import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export class PhoneVerifyData {
  verificationCode = '';
  resendCode = false;
  noCode = false;
  constructor() {}
}

@Component({
  selector: 'alerts-component',
  template: `
    <div class="input-wrapper">
      <div class="row">
        <div class="col">
          <h5 class="title" translate="msgNewinMyLion">
            What's new in MyLion?
          </h5>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <h6 style="margin-bottom: 0;">{{ alert.header }}</h6>
          <p>{{ alert.body }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col" style="text-align: center;">
          <app-button (click)="cancel()" style="display: inline-block;"
            >THANKS!</app-button
          >
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      select,
      input {
        height: 30px !important;
        font-size: 14px;
        font-family: 'Helvetica Neue';
      }
      h6 {
        font-size: 14px;
        font-weight: bold;
      }
      label {
        font-size: 14px;
      }
      h5 {
        font-size: 24px;
        font-weight: bold;
        font-family: 'Helvetica Neue';
        display: inline-block;
      }
      h5.title {
        border-bottom: 4px solid #f65126;
        margin-bottom: 30px;
      }

      p {
        font-size: 14px;
      }

      p a {
        font-style: italic;
      }
      .input-wrapper {
        padding-top: 25px;
        padding-bottom: 25px;
      }
    `
  ]
})
export class AlertsComponent {
  alert: any = {};
  constructor(
    public dialogRef: MatDialogRef<AlertsComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: Array<any>
  ) {
    if (data) {
      this.alert = data;
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
